import axios from "axios";
import config from "../../config";
import {
  CreateMdaExtractMappingRequest,
  MappingPositionUpdate,
  MdaExtractMappingDetail,
  UpdateMdaExtractMappingRequest,
} from "./types";

const apiUrl = config.api;

export const listMappingsForClient = async (
  clientId: number,
): Promise<MdaExtractMappingDetail[]> => {
  const response = await axios.get<MdaExtractMappingDetail[]>(
    `${apiUrl}/mda/spreadsheet/mappings/client/${clientId}`,
  );

  return response.data;
};

export const createMapping = async (
  body: CreateMdaExtractMappingRequest,
): Promise<void> => {
  await axios.post(`${apiUrl}/mda/spreadsheet/mappings`, body);
};

export const updateMapping = async (
  body: UpdateMdaExtractMappingRequest,
): Promise<void> => {
  await axios.put(`${apiUrl}/mda/spreadsheet/mappings`, body);
};

export const deleteMapping = async (id: number): Promise<void> => {
  await axios.delete(`${apiUrl}/mda/spreadsheet/mappings/${id}`);
};

export const reorderMappings = async (
  clientId: number,
  positions: MappingPositionUpdate[],
): Promise<void> => {
  await axios.put(
    `${apiUrl}/mda/spreadsheet/mappings/client/${clientId}/reorder`,
    positions,
  );
};

export const listAvailableSourceColumns = async (): Promise<string[]> => {
  const response = await axios.get<string[]>(
    `${apiUrl}/mda/spreadsheet/columns`,
  );

  return response.data;
};
